import Countdown from '@liveauctioneers/caterwaul-components/lib/Countdown/Countdown';
import styled, { css } from 'styled-components';

export type BiddingCountdownProps = {
    className?: string;
    isLive: boolean;
    onCountdownEnd?: () => void;
    timestamp: number;
};

const BiddingCountdown = ({ className, isLive, onCountdownEnd, timestamp }: BiddingCountdownProps) => {
    return (
        <div suppressHydrationWarning>
            <StyledCountdown
                $isLive={isLive}
                className={className}
                data-testid="countdown"
                daysText="day"
                extendedCount={false}
                hoursText="hr"
                minutesText="min"
                onCountdownEnd={onCountdownEnd}
                secondsText="sec"
                seperatorText=""
                showSeconds
                timeStamp={timestamp}
            />
        </div>
    );
};

export default BiddingCountdown;

const StyledCountdown = styled(Countdown)<{ $isLive: boolean }>`
    ${({ $isLive, theme }) => css`
        @media screen {
            &&& {
                color: ${$isLive ? theme.colors.red100 : theme.colors.black};
                display: block;
                font-size: unset;
            }
        }
    `}
`;
